<template>
  <div class="body"></div>
  <RoomCard :item="item" :reserveButtonVisible="false"></RoomCard>
  <div class="container border rounded">
    <div class="row">
      <div class="col mt-4">
        <div class="float-left">ご予約日</div>
        <v-date-picker
          v-model='selectedDate'
          :masks="{ title: 'YYYY年 MMM' }"
          :model-config="calendarModelConfig"
          :min-date='setMinDate()'
          :max-date='setMaxDate()'
          :disabled-dates='disabledDates'
          :columns="$screens({ default: 1, lg: 2 })"
          :attributes="attributes"
          is-expanded
          @dayclick="getReservation(true)"
          >
          <template #day-popover>
            <div>
              予約が埋まっているためご利用できません
            </div>
          </template>
        </v-date-picker>
      </div>
    </div>
    <div class="row">
      <div class="col mt-4">
        <div>ご利用時間帯</div>
      </div>
    </div>
    <ReserveProgress
      :reservedTimes="reservedTimes"
      :enabled="this.isEnabled()"
      :selectedDate="selectedDate">
      </ReserveProgress>
    <ReserveFromToTime
      :reservedTimes="reservedTimes"
      :enabled="this.isEnabled()"
      :restoreSelectedFromTime="this.reserveFromTime"
      :restoreSelectedToTime="this.reserveToTime"
      :selectedDate="selectedDate"
      @catcSelectedFromTime="setSelectedFromTime"
      @catcSelectedToTime="setSelectedToTime"
      @changeDisabled="changeDisabled"
      ></ReserveFromToTime>
    <div class="row">
      <div class="col mt-4">
        <div>ご予約人数</div>
        <div class="dropdown">
          <button class="btn dropdown-toggle border rounded" type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            {{ selectedPersonNum }}
          </button>
          <ul class="dropdown-menu scroller" aria-labelledby="dropdownMenuButton1">
            <template v-for="(num, index) in dropDownPersonNum" :key="index" >
              <li><button class="dropdown-item" @click="setSelectedPersonNum(num)" value="num">{{ num }}人</button></li>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mt-4">
        <div v-if="isFree()">
          <div class="row">
            <div class="col-auto">訪問者</div>
            <div class="form-check mx-2 col-auto">
              <input class="form-check-input" type="checkbox" id="personChecked" v-model="isChanged" @change="changeVisiters">
              <label class="form-check-label" for="personChecked">
                ログインユーザーと同じ
              </label>
            </div>
          </div>
          <template v-for="(num, index) in selectedPersonNum" :key="index" >
            <input type="text" :id="'userName' + index" v-model="inputVisiters[index]" maxlength="20" />
          </template>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-auto">代表訪問者</div>
            <div class="form-check mx-2 col-auto">
              <input class="form-check-input" type="checkbox" id="personChecked" v-model="isChanged" @change="changeVisiters">
              <label class="form-check-label" for="personChecked">
                ログインユーザーと同じ
              </label>
            </div>
          </div>
          <template v-for="(num, index) in delegateNum" :key="index" >
            <input type="text" :id="'userName' + index" v-model="inputVisiters[index]" maxlength="20" />
          </template>
        </div>
        
      </div>
    </div>
    <div class="row">
      <div class="col mt-4">
        <div v-if="isHall()">利用目的</div>
        <div v-else>ご利用メモ</div>
        <textarea id="memo" class="memo" v-model="inputMemo" maxlength="500" />
      </div>
    </div>
    <div class="text-center">
      <button type="button" class="btn btn-primary mt-4 mb-2 text-center w-25"
        @click="reserveClick()" :disabled="isButtonDisabled || isDisabled">予約</button>
    </div>
  </div>
  <!-- <div class="space"></div> -->
</template>

<script>
import RoomCard from './RoomCard.vue'
import ReserveProgress from './ReserveProgress.vue'
import ReserveFromToTime from './ReserveFromToTime.vue'
import reserveMixin from '@/mixins/reserveMixin.js'
import authMixin from '@/mixins/authMixin.js'
import Const from '../const'
import axios from 'axios'

export default {
  name: 'RoomRoom',
  components: {
    RoomCard,
    ReserveProgress,
    ReserveFromToTime,
  },

  data: () => ({
    serverTime: new Date(),
    // カレンダーのフォーマット
    calendarModelConfig: {
      type: 'string',
      mask: 'YYYY-MM-DD',
    },
    disabledDates: [{ start: null, end: null }],
    // ドロップダウン用の予約人数データ
    dropDownPersonNum: [],
    // 予約情報の格納
    selectedDate: '',
    selectedFromTime: { 'label': '', 'value': '' },
    selectedToTime: { 'label': '', 'value': '' },
    selectedPersonNum: 1,
    delegateNum: 1,
    inputVisiters: [],
    reservedTimes: [],
    inputMemo: '',
    errorMessages: [],
    isDisabled: false,
    isChanged: false,
    rentDates: []
  }),
  async created() {
    await this.getServerTime()
    // スクロールをトップに固定
    window.scrollTo(0, 0);
    if (!this.item.name) {
      // ストアに選択したプランが存在しない予約一覧画面へ遷移
      this.$router.push({ name: 'roomList' });
    }
    else if (this.$router.referrer.path == '/reserveConfirm') {
      // ストア情報から選択地を復元
      this.selectedDate = this.reserveDate;
      this.getReservation(false);
      this.selectedPersonNum = this.personNum;
      this.inputVisiters = this.visiters;
      this.inputMemo = this.memo;
    } else {
      // 今日の日付を初期値に設定 <- 今日が休館日だった場合に選択で来てしまうので無効化
      // this.selectedDate =new Date().toISOString().split("T")[0];
      this.getReservation(false);
      // 不要なストア情報を初期化
      this.$store.dispatch('clearReserveDate');
      this.$store.dispatch('clearReserveTimes');
      this.$store.dispatch('clearPersonNum');
      this.$store.dispatch('clearVisiters');
      this.$store.dispatch('clearMemo');
    }
    this.disabledDates = await this.getDisabledDates()
    this.setPersonNum()
    if (this.isHall()) {
      this.getRentDates("hall")
    }
    if (this.isConference()) {
      this.getRentDates("conference")
    }
  },
  methods: {
    async getServerTime() {
      try {
        const response = await axios.get(Const.BASE_URL + "/fetch-server-time", {
          headers: {
            "Authorization": this.$store.getters.token,
            "Content-Type": "application/json"
          }
        })
        this.serverTime = new Date(response.data)
      } catch (error) {
        if (error.response.status === 403) {
          this.$router.push("login");
        }
      }
      return this.serverTime
    },
    reserveClick: function () {
      // ストアに情報を格納
      this.$store.dispatch('updateReserveDate', this.selectedDate);
      this.$store.dispatch('updateReserveFromTime', this.selectedFromTime);
      this.$store.dispatch('updateReserveToTime', this.selectedToTime);
      this.$store.dispatch('updatePersonNum', this.selectedPersonNum);
      this.$store.dispatch('updateVisiters', this.inputVisiters);
      this.$store.dispatch('updateMemo', this.inputMemo);
      // 予約確認画面へ遷移
      this.$router.push({ name: 'reserveConfirm' });
    },
    setSelectedFromTime: function (val) {
      this.selectedFromTime = val;
    },
    setSelectedToTime: function (val) {
      this.selectedToTime = val;
    },
    setSelectedPersonNum: function (val) {
      this.selectedPersonNum = val;
    },
    // ドロップダウンの表示人数
    setPersonNum() {
      if (this.isFree()) {
        this.dropDownPersonNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      }
      if (this.isConference()) {
        this.dropDownPersonNum = [1, 2, 3, 4, 5, 6, 7, 8]
      }
      if (this.isHall()) {
        this.dropDownPersonNum = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
      }
      return this.dropDownPersonNum
    },
    // 表示非表示の判定
    isEnabled: function () {
      return this.selectedDate ? true : false;
    },
    setMinDate() {
      const now = new Date(this.serverTime)
      return now
    },
    setMaxDate() {
      const date = new Date(this.serverTime)
      date.setDate(date.getDate() + 180)

      return date
    },
    // 予約済み時間取得
    getReservation: function (flg) {
      if (flg) {
        // 日付クリック時に復元情報をクリアする
        this.$store.dispatch('clearReserveTimes');
      }
      // 日付未選択またはフリーの場合は空を返却
      if (!this.selectedDate || this.isFree()) {
        this.reservedTimes = [];
        return;
      }

      axios.get(Const.BASE_URL + "/reservation",
        {
          headers: {
            "Authorization": this.$store.getters.token,
            "Content-Type": "application/json"
          },
          params: { 'reservation_date': this.selectedDate.replaceAll('-', '') }
        }
      ).then((res) => {
        // console.log(res.data);
        var data = res.data;
        // 不要なプランの情報を削除
        data = data.filter((ele) => this.plan == ele.plan_id);
        // console.log(data)

        // 数値変換した値を追加
        data.forEach((ele) => {
          ele['start'] = Number(ele.start_time);
          ele['end'] = Number(ele.end_time);
        });
        this.reservedTimes = data;
        // console.log(this.reservedTimes);
      });
    },
    // 無効化する日付を設定する関数
    async getDisabledDates() {
      const returnDates = []
      // 土日を無効化
      returnDates.push({ weekdays: [1, 7] });
      // 本日より前の日付を無効化
      // returnDates.push({ start: null, end: new Date().setDate(new Date().getDate() - 1) });
      // 6ヶ月後以後を無効化
      // returnDates.push({ start: new Date().setMonth(new Date().getMonth() + 6), end: null });
      try {
        const headers = {
          "Authorization": this.$store.getters.token,
          "Content-Type": "application/json"
        }
        const response = await axios.get(Const.BASE_URL + "/closed-days", { headers })
        response.data.forEach((data) => {
          const strDate = this.dateLabeling(data)
          returnDates.push(new Date(strDate))
        })
      } catch (error) {
        // エラーハンドラ
      }
      return returnDates;
    },
    // 日付のフォーマットをyyyymmddからyyyy-mm-ddにする関数
    dateLabeling(value) {
      if (typeof value === "string") {
        const date =
          value.substr(0, 4) +
          "-" +
          value.substr(4, 2) +
          "-" +
          value.substr(6, 2);
        return date;
      }
      return value;
    },
    changeDisabled(isDisabled) {
      this.isDisabled = isDisabled
    },
    changeVisiters() {
      if (this.isChanged) {
        this.inputVisiters[0] = this.$store.getters.personalName
      } else {
        this.inputVisiters[0] = ""
      }
    },
    getRentDates(plan_id) {
      axios.get(Const.BASE_URL + "/fetch-reservation-sold-out", {
        headers: {
          "Authorization": this.$store.getters.token,
          "Content-Type": "application/json"
        },
        params: {
          "plan_id": plan_id
        }
      })
        .then(function (response) {
          // console.log(response)
          response.data.reservations.forEach(date => {
            const strDate = this.dateLabeling(date)
            this.rentDates.push(strDate)
          })
        }.bind(this))
        .catch(function () {
        })
    }
  },
  computed: {
    // 未選択の場合は予約ボタンが不活性
    isButtonDisabled: function () {
      if (!this.selectedDate || !this.selectedFromTime.label || !this.selectedToTime.label) {
        return true
      }
      return false
    },
    attributes() {
      return [
        {
          key: "rentDates",
          highlight: "gray",
          dates: this.rentDates,
          popover: {
            label: "予約が埋まっているためご利用できません"
          }
        }
      ]
    }
  },
  mixins: [reserveMixin, authMixin],
}
</script>

<style scoped>
.space {
  margin-bottom: 0;
}

.scroller {
  height: 200px;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}

.memo {
  width: 100%;
  height: 8em;
}

.body {
  padding-top: 70px;
}

input[type=checkbox] {
  transform: scale(0.8);
}

.form-check-input {
  margin-left: -1.3em !important;
}
</style>
